import Vue from 'vue';
import Component from 'vue-class-component';
import { io, Socket } from 'socket.io-client';
import { BOARD_EVENTS } from '@/values/ed-whiteboard.values';
import { NETWORK_SETTINGS } from '@/core/values/app.values';
import { AuthProvider } from '@/auth/providers/auth.provider';

@Component({})
export default class WhiteboardMixin extends Vue {

  public socket : Socket = null;

  get wboTaskSocketUrl() : string {
    return this.$store.state.AuthStore.wboTaskSocketUrl;
  }

  public createSocketConnection() : void {    
    // Destroy socket if one already exists
    this.disconnectSocket();

    this.socket =  io(this.wboTaskSocketUrl, {
      ...NETWORK_SETTINGS.socketIo.connection,
      transports: ['websocket'],
      auth: { token: AuthProvider.getToken() }
    });
    this.socket.io.on('reconnect_attempt', () => {
      this.socket.auth = { token: AuthProvider.getToken() };
    });

    this.socket.on('board_joined', (msg : any) => {
      if(!msg.boardName){
        return;
      }
      
      this.$edEventBus.$emit(`${msg.boardName}${BOARD_EVENTS.JOINED}`, msg);
    });

    //Receive draw instructions from the server
    this.socket.on('broadcast', async (msg : any) => {
      if(!msg.boardName){
        return;
      }
      
      this.$edEventBus.$emit(msg.boardName, msg);
    });
    
  }

  public disconnectSocket() : void {    
    if (this.socket) {
      this.socket.disconnect();
      this.socket.removeAllListeners();
      this.socket = null;
    }
  }
}
